import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Snackbar, Alert } from "@mui/material"; // Import for alert messaging
import questionsData from "../../data/questions.json";

const QuestionLayout = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const navigate = useNavigate();
  const questionIndex = parseInt(id) - 1;

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [openWarning, setOpenWarning] = useState(false); // Controls warning visibility

  useEffect(() => {
    // Reset selections when moving to a new question
    setSelectedOptions([]);
  }, [id]); // Trigger when id changes

  if (!questionsData[questionIndex]) {
    return <h2>404 - {t("questionNotFound")}</h2>;
  }

  const question = questionsData[questionIndex];

  const handleSelectOption = (option) => {
    if (question.multiSelect) {
      setSelectedOptions((prev) =>
        prev.includes(option)
          ? prev.filter((item) => item !== option)
          : [...prev, option]
      );
    } else {
      setSelectedOptions([option]);
    }
  };

  const handleGoBack = () => {
    if (questionIndex === 0) {
      navigate("/questionInfo");
    } else {
      navigate(`/questions/${questionIndex}`);
    }
  };

  const handleSkip = () => {
    if (questionIndex + 1 < questionsData.length) {
      navigate(`/questions/${questionIndex + 2}`);
    }
  };

  const handleSkipAllTest = () => {
    navigate("/userHomePage");
  };

  const handleNext = async () => {
    if (selectedOptions.length === 0) {
      setOpenWarning(true); 
      return;
    }

    // Mevcut cevabı kaydet (localStorage veya başka bir yöntemle biriktirilebilir)
    const currentAnswers = JSON.parse(localStorage.getItem("registrationAnswers") || "{}");
    currentAnswers[question.id] = selectedOptions;
    localStorage.setItem("registrationAnswers", JSON.stringify(currentAnswers));

    if (questionIndex + 1 < questionsData.length) {
      navigate(`/questions/${questionIndex + 2}`);
    } else {
      // Test bittiğinde userHomePage'e yönlendir
      navigate("/userHomePage");
    }
  };

  return (
    <div className="bg-background w-full max-w-[900px] mx-auto mt-12 p-8 rounded-[15px] shadow-lg">
      {/* Top Navigation */}
      <div className="flex justify-between items-center">
        <button
          className="flex items-center justify-center w-[100px] md:w-[117px] h-[35px] md:h-[39px] border-[1px] md:border-[1px] border-cards-border rounded-[10px] md:rounded-[15px] text-white bg-button-bg font-poppins text-[12px] md:text-[14px] mb-6 md:mb-8 mt-6"
          onClick={handleGoBack}
        >
          <span className="w-[20px] md:w-[24px] h-[20px] md:h-[24px] flex items-center justify-center">&#10094;</span> {t("goToBack")}
        </button>

        <div className="flex items-center">
          <button
            className=" px-4 py-2 border-[2px] border-button-bg rounded-l-[15px] text-text font-poppins hover:bg-button-bg hover:text-white transition"
            onClick={handleSkip}
          >
            {t("skip")}
          </button>
          <button
            className="px-4 py-2 border-[2px] border-button-bg rounded-r-[15px] bg-button-bg text-white font-poppins hover:opacity-90 transition"
            onClick={handleSkipAllTest}
          >
            {t("skipAllTest")}
          </button>
        </div>
      </div>

      {/* Soru ve Progress */}
      <div className="flex items-center gap-4 mt-8 max-w-[620px] ">
        <div className="flex items-center justify-center bg-button-bg w-12 h-12 text-white rounded-full text-lg font-bold font-poppins ml-12">
          {questionIndex + 1}/{questionsData.length}
        </div>
        <h2 className="flex-1 text-center text-xl font-bold font-poppins text-text">
          {t(`questions.${question.id}.title`)}
        </h2>
      </div>

      {/* Options */}
      <div className="mt-8 flex flex-col items-center">
        {t(`questions.${question.id}.options`, { returnObjects: true }).map((option, index) => (
          <button
            key={index}
            className={`w-full max-w-[620px] flex py-3 px-4 mb-4 border-2 border-cards-border rounded-full text-text font-poppins text-lg transition ${
              selectedOptions.includes(option)
                ? "bg-button-bg text-white border-button-bg"
                : "bg-[#FFFFFF] hover:bg-button-bg hover:text-white"
            }`}
            onClick={() => handleSelectOption(option)}
          >
            {option}
          </button>
        ))}
      </div>

      {/* Continue Butonu */}
      <div className="flex justify-center mt-8 ">
        <button
          className="px-6 py-3 w-[476px] h-[61px] bg-button-bg text-white font-bold font-poppins text-lg rounded-full hover:opacity-90 transition"
          onClick={handleNext}
        >
          {questionIndex + 1 === questionsData.length ? t("finish") : t("continue")}
        </button>
      </div>

      {/* Warning Snackbar */}
      <Snackbar
        open={openWarning}
        autoHideDuration={3000}
        onClose={() => setOpenWarning(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert severity="warning" onClose={() => setOpenWarning(false)}>
        {t("pleaseChooseAnOption")}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default QuestionLayout;
